import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PortafolioService {

  portafolio:any[]=[
    {
      tipoFilter:'filter-web',
      img:'assets/img/portfolio/portafolio-admin.jpg',
      subtitulo:'Encriptador Texto Web',
      descripcion:'Aplicación para encriptar texto HTML, CSS y JAVASCRIPT',
      github:'https://github.com/YuniorAlex/EncriptadorTexto',
      direccionWeb: 'https://encriptadortexto.netlify.app/'
    },
    // {
    //   tipoFilter:'filter-web',
    //   img:'assets/img/portfolio/portafolio-admin.jpg',
    //   subtitulo:'Web Angular',
    //   descripcion:'Aplicación Web',
    //   github:'https://github.com/YuniorAlex/Angular-admin'
    // },
    // {
    //   tipoFilter:'filter-app',
    //   img:'assets/img/portfolio/portafolio-mobile.jpg',
    //   subtitulo:'App mobile',
    //   descripcion:'Aplicación Mobile',
    //   github:'https://github.com/YuniorAlex/Angular-admin'
    // },
    // {
    //   tipoFilter:'filter-app',
    //   img:'assets/img/portfolio/portafolio-mobile.jpg',
    //   subtitulo:'App Android',
    //   descripcion:'Aplicación Android',
    //   github:'https://github.com/YuniorAlex/Angular-admin'
    // },
    // {
    //   tipoFilter:'filter-card',
    //   img:'assets/img/portfolio/portafolio-api.jpg',
    //   subtitulo:'Service',
    //   descripcion:'Aplicación desarrollado con el fremework de .Net Core 3.1',
    //   github:'https://github.com/YuniorAlex/Angular-admin'
    // },
  ]

  constructor() { }
}
